export default {
  subscription: {
    manage: "Gestionar suscripción",
    page_title: "Gestión de suscripción",
    page_subtitle:
      "Gestione la configuración de su suscripción y la configuración de renovación automática",
    current_subscription: "Suscripción actual",
    plan: "Plan",
    billing_cycle: "Ciclo de facturación",
    status: "Estado",
    subscription_control: "Control de suscripción",
    auto_renew_cancelled:
      "La renovación automática ha sido cancelada y el servicio se detendrá después de que expire el {date}.",
    cancel_effect:
      "La cancelación de su suscripción surtirá efecto después del final del ciclo de facturación actual. Su suscripción permanecerá activa hasta el {date}.",
    restore_prompt:
      "Su suscripción ha sido cancelada o se cancelará después del final del ciclo de facturación actual. Para continuar usando nuestros servicios, por favor restaure su suscripción.",
    cancel_processing:
      "Su solicitud de cancelación de suscripción está siendo procesada y surtirá efecto después del final del ciclo de facturación actual.",
    restore_processing: "Su solicitud de restauración de suscripción está siendo procesada.",
    expired_desc:
      "Su suscripción ha expirado. Por favor actualice su información de pago para restaurar el servicio.",
    paused:
      "Su suscripción está actualmente en pausa. Las operaciones de cancelación o restauración no están disponibles.",
    trialing:
      "Actualmente se encuentra en período de prueba. La suscripción se convertirá automáticamente en una suscripción de pago después de que expire el período de prueba.",
    no_action: "El estado actual de su suscripción no admite acciones.",
    cancel_subscription_btn: "Cancelar suscripción",
    restore_subscription_btn: "Restaurar suscripción",
    restoring: "Restaurando...",
    cancelling: "Cancelando...",
    status_unavailable: "Estado no disponible",
    no_active_subscription: "No tiene una suscripción activa",
    choose_plan: "Elegir plan",
    cancel_modal_title: "Cancelar suscripción",
    cancel_confirm:
      "¿Está seguro de que desea cancelar su suscripción? Esto surtirá efecto después del final del ciclo de facturación actual ({date}). Después de eso, su suscripción será desactivada y perderá el acceso a las funciones premium.",
    reason_label: "Razón (Opcional):",
    reason_placeholder: "Por favor comparta por qué está cancelando...",
    status_updated: "Estado de suscripción actualizado",
    cancel_request_submitted: "Solicitud de cancelación de suscripción enviada",
    cancel_failed: "Error al cancelar la suscripción",
    restore_request_submitted: "Solicitud de restauración de suscripción enviada",
    restore_failed: "Error al restaurar la suscripción",
    active: "Activo",
    canceled: "Cancelado",
    cancel_pending: "Cancelación pendiente",
    restore_pending: "Restauración pendiente",
    past_due: "Vencido",
    paused_status: "En pausa",
    trialing_status: "Período de prueba",
    next_cycle_cancel: "Cancelación en el próximo ciclo",
    unknown_status: "Estado desconocido",
    monthly: "Mensual",
    yearly: "Anual",
  },
  invoices: {
    recent: "Facturas recientes",
    number: "Número de factura",
    order_no: "Número de pedido",
    amount: "Monto",
    status: "Estado",
    created_at: "Creado el",
    actions: "Acciones",
    status_issued: "Emitida",
    status_paid: "Pagada",
    status_voided: "Anulada",
    view_all: "Ver todas las facturas",
  },
  orders: {
    no: "Número de pedido",
    plan_type: "Tipo de plan",
    duration: "Duración",
    amount: "Monto",
    status: "Estado",
    paid_at: "Pagado el",
    created_at: "Creado el",
    actions: "Acciones",
    quantity: "Cantidad",
    status_pending: "Pendiente",
    status_paid: "Pagado",
    status_failed: "Fallido",
    status_refunded: "Reembolsado",
    refund_pending: "Reembolso pendiente",
    refund_failed: "Error en reembolso",
    cancelled: "Cancelado",
    expired: "Expirado",
    days: "días",
    cancel_confirm: "¿Está seguro de que desea cancelar este pedido?",
    delete_confirm: "¿Está seguro de que desea eliminar este pedido?",
    downloading_invoice: "Descargando factura...",
    download_failed: "Error en descarga",
    check_refund: "Verificando elegibilidad para reembolso...",
    refund_not_eligible: "No elegible para reembolso",
    check_refund_failed: "Error al verificar elegibilidad para reembolso",
    prorated_refund_title: "Reembolso prorrateado",
    prorated_refund_content: "Este reembolso se calculará prorrateado según su uso.",
    credits_refund_content: "Este reembolso se calculará prorrateado según los créditos restantes.",
    full_refund_title: "Reembolso completo",
    full_refund_content: "Es elegible para un reembolso completo.",
    request_refund: "Solicitar reembolso",
    processing_refund: "Procesando solicitud de reembolso...",
    refund_request_failed: "Error en solicitud de reembolso",
    refund_reason: "Razón del reembolso",
    refund_reason_placeholder: "Por favor ingrese una razón para el reembolso...",
    refund_reason_required: "Se requiere la razón del reembolso",
    refund_conditions: "Condiciones de reembolso",
    no_report_generated: "No se generó informe",
    no_calculations_performed: "No se realizaron cálculos",
    no_api_used: "No se usó API",
    subscription_period: "Período de suscripción",
    subscription_details: "Detalles de suscripción",
    total_days: "Días totales",
    remaining_days: "Días restantes",
    refund_amount: "Monto del reembolso",
    refund_reasons: {
      order_not_found: "Pedido no encontrado",
      unauthorized: "Acceso no autorizado",
      order_not_completed: "Solo se pueden reembolsar pedidos completados",
      subscription_not_found: "Suscripción no encontrada",
      paid_features_used: "Se utilizaron funciones pagas durante el período de suscripción",
      internal_error: "Ocurrió un error interno al verificar la elegibilidad para reembolso",
    },
    calculation_quota: "Cuota de cálculo",
    report_quota: "Cuota de informe",
    quota_info: "{purchased} {type} comprados, {used} usados, {remaining} restantes",
    quota_detail: "{purchased} comprados, {used} usados, {remaining} restantes",
    no_credits_used: "No se usaron créditos",
    refund_requested: "Solicitud de reembolso enviada con éxito",
    refund_pending_approval:
      "Solicitud de reembolso enviada. El reembolso está pendiente y puede tomar algún tiempo procesarlo.",
    refund_approved: "Reembolso aprobado con éxito",
    refund_rejected: "La solicitud de reembolso fue rechazada",
    refund_success: "Reembolso exitoso",
    refund_processing: "Procesando reembolso",
    refund_success_message:
      "Hemos procesado su reembolso con éxito. Puede tomar hasta 5 días hábiles para que el dinero se acredite en su cuenta.",
    refund_processing_message: "Su reembolso aún se está procesando, por favor tenga paciencia.",
    checking_order_status: "Verificando estado del pedido...",
  },
};
